module.exports = __webpack_public_path__ + "img/avatar0.6a54d9a4.png";